/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Event_Ad_Auto_Rate_Failed_ToastInputs */

const en_event_ad_auto_rate_failed_toast = /** @type {(inputs: Event_Ad_Auto_Rate_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Auto rate failed: ${i?.message}`)
};

const fr_event_ad_auto_rate_failed_toast = /** @type {(inputs: Event_Ad_Auto_Rate_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec du taux automatique : ${i?.message}`)
};

const de_event_ad_auto_rate_failed_toast = /** @type {(inputs: Event_Ad_Auto_Rate_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Automatische Bewertung fehlgeschlagen: ${i?.message}`)
};

const it_event_ad_auto_rate_failed_toast = /** @type {(inputs: Event_Ad_Auto_Rate_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tasso automatico non riuscito: ${i?.message}`)
};

const ru_event_ad_auto_rate_failed_toast = /** @type {(inputs: Event_Ad_Auto_Rate_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Автоматическая оценка не удалась: ${i?.message}`)
};

const es_event_ad_auto_rate_failed_toast = /** @type {(inputs: Event_Ad_Auto_Rate_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error en la tasa automática: ${i?.message}`)
};

const zh_cn2_event_ad_auto_rate_failed_toast = /** @type {(inputs: Event_Ad_Auto_Rate_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`自动评分失败：${i?.message}`)
};

const ja_event_ad_auto_rate_failed_toast = /** @type {(inputs: Event_Ad_Auto_Rate_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`自動評価に失敗しました: ${i?.message}`)
};

const hi_event_ad_auto_rate_failed_toast = /** @type {(inputs: Event_Ad_Auto_Rate_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`स्वचालित दर निर्धारण विफल: ${i?.message}`)
};

const pt_pt2_event_ad_auto_rate_failed_toast = /** @type {(inputs: Event_Ad_Auto_Rate_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A taxa automática falhou: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Auto rate failed: {message}" |
*
* @param {Event_Ad_Auto_Rate_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_auto_rate_failed_toast = /** @type {((inputs: Event_Ad_Auto_Rate_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Auto_Rate_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_ad_auto_rate_failed_toast(inputs)
	if (locale === "de") return de_event_ad_auto_rate_failed_toast(inputs)
	if (locale === "it") return it_event_ad_auto_rate_failed_toast(inputs)
	if (locale === "ru") return ru_event_ad_auto_rate_failed_toast(inputs)
	if (locale === "es") return es_event_ad_auto_rate_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_event_ad_auto_rate_failed_toast(inputs)
	if (locale === "ja") return ja_event_ad_auto_rate_failed_toast(inputs)
	if (locale === "hi") return hi_event_ad_auto_rate_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_event_ad_auto_rate_failed_toast(inputs)
	return en_event_ad_auto_rate_failed_toast(inputs)
});